'use client';

import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { LineProgressBar } from '@/features/progress-bar';
import { cn } from '@/utils/cn';
import { byDevice } from '../../_utils/carousel-layout';
import { IRANIAN_WOMEN_CAROUSEL } from '../../constants';
const getSlideStep = (isMobile: boolean) => {
  const containerWidth = byDevice(IRANIAN_WOMEN_CAROUSEL.containerWidth, isMobile);
  const spacing = byDevice(IRANIAN_WOMEN_CAROUSEL.slideSpacing, isMobile);
  const perView = byDevice(IRANIAN_WOMEN_CAROUSEL.perView, isMobile);
  const slotSize = (containerWidth - spacing * (perView - 1)) / perView;
  return slotSize + spacing;
};
const WomenSliderSkeleton = () => {
  const {
    isMobile
  } = useMobileDetect();
  const slideCount = byDevice(IRANIAN_WOMEN_CAROUSEL.skeletonSlideCount, isMobile);
  const centerIndex = Math.floor(slideCount / 2);
  const visibleSideCount = byDevice(IRANIAN_WOMEN_CAROUSEL.maxVisibleSideCount, isMobile);
  const slideStep = getSlideStep(isMobile);
  const sizes = byDevice(IRANIAN_WOMEN_CAROUSEL.scaledSizes, isMobile);
  const activeSlideSize = isMobile ? IRANIAN_WOMEN_CAROUSEL.scaledSizes.mobile[0] : IRANIAN_WOMEN_CAROUSEL.scaledSizes.desktop[0];
  return <div className='mx-auto flex w-full flex-col lg:mx-auto lg:max-w-4xl' data-sentry-component="WomenSliderSkeleton" data-sentry-source-file="women-slider-skeleton.tsx">
            <LineProgressBar percent={2} mainBarclassName='h-0.5 lg:h-1 bg-gray-100' activeBarClassName='h-0.5 lg:h-1 bg-gray-200' className='order-3 mt-5 flex-col-reverse lg:order-1 lg:mb-10 lg:mt-0' data-sentry-element="LineProgressBar" data-sentry-source-file="women-slider-skeleton.tsx">
                <div className='mb-1 flex w-full items-center justify-center gap-1 text-caption-12 font-bold lg:text-base'>
                    <div className='h-3 w-6 animate-pulse rounded bg-gray-200 lg:h-4 lg:w-8' />
                    <span className='text-text-darkGray'>/</span>
                    <div className='h-3 w-4 animate-pulse rounded bg-gray-300 lg:h-4 lg:w-6' />
                </div>
            </LineProgressBar>

            <div className='navigation-wrapper group relative order-1 w-full lg:order-2'>
                <div className='absolute -left-6 top-1/2 z-40 hidden h-9 w-9 -translate-y-1/2 animate-pulse rounded-full bg-gray-100 lg:block' />
                <div className='absolute -right-6 top-1/2 z-40 hidden h-9 w-9 -translate-y-1/2 animate-pulse rounded-full bg-gray-100 lg:block' />

                <div className='relative mx-auto w-full overflow-hidden' style={{
        height: activeSlideSize
      }}>
                    {Array.from({
          length: slideCount
        }, (_, index) => {
          const distance = Math.abs(index - centerIndex);
          const isVisible = distance <= visibleSideCount;
          const isActive = distance === 0;
          const isFirstNeighbour = distance === 1;
          const isSecondNeighbour = distance === 2;
          const isThirdNeighbour = distance === 3;
          const x = (index - centerIndex) * slideStep;
          const size = sizes[distance] ?? sizes[sizes.length - 1];
          return <div key={index} className={cn('absolute left-1/2 top-1/2 animate-pulse rounded-lg border border-border-gray-light bg-gray-100', !isVisible && 'opacity-0', isActive && 'z-30', isFirstNeighbour && 'z-20', isSecondNeighbour && 'z-10', isThirdNeighbour && 'z-[5]')} style={{
            width: size,
            height: size,
            transform: `translate(calc(-50% + ${x}px), -50%)`
          }} />;
        })}
                </div>
            </div>

            <div className='order-1 mt-5 flex flex-col items-center gap-2 lg:order-3 lg:mt-10 lg:gap-4'>
                <div className='h-5 w-36 animate-pulse rounded bg-gray-100 lg:h-6 lg:w-44' />
                <div className='h-4 w-28 animate-pulse rounded bg-gray-100 lg:h-5 lg:w-36' />
                <div className='h-7 w-52 animate-pulse rounded border border-border-gray-light bg-gray-50 lg:h-9 lg:w-64' />
                <div className='hidden w-full max-w-2xl flex-col items-center gap-1.5 px-4 lg:flex'>
                    {[100, 101, 96, 88, 72].map(width => <div key={width} className='h-4 animate-pulse rounded bg-gray-100' style={{
          width: `${width}%`
        }} />)}
                </div>
            </div>
        </div>;
};
export default WomenSliderSkeleton;